var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentMagentoClient } from "@jti/magento";
import { setFreeGiftsErrors } from "../../cartSlice";
import { fetchCartPrices, fetchTrialCartPrices } from "../fetchCartPrices";
const fetchItemsDeclaration = (isFreeTrial) => createAsyncThunk(isFreeTrial ? "freeTrialCart/fetchCartItems" : "cart/fetchCartItems", (cartId_1, _a) => __awaiter(void 0, [cartId_1, _a], void 0, function* (cartId, { dispatch }) {
    const items = yield getCurrentMagentoClient(isFreeTrial).getCartItems(cartId);
    if (isFreeTrial) {
        dispatch(fetchTrialCartPrices(cartId));
    }
    else {
        dispatch(fetchCartPrices(cartId));
    }
    return items;
}));
const fetchCartItemsWithValidations = (isFreeTrial) => createAsyncThunk(isFreeTrial ? "freeTrialCart/fetchCartItemsWithValidation" : "cart/fetchCartItemsWithValidation", (cartId_1, _a) => __awaiter(void 0, [cartId_1, _a], void 0, function* (cartId, { dispatch }) {
    let items = yield getCurrentMagentoClient(isFreeTrial).getCartItems(cartId);
    const freeGiftsWithErrors = items.items.filter((item) => item.isGift && !!item.errors);
    if (freeGiftsWithErrors.length > 0) {
        yield getCurrentMagentoClient(isFreeTrial).removeItemsFromCart(cartId, freeGiftsWithErrors.map((item) => item.id || "").filter((id) => !!id));
        items = yield getCurrentMagentoClient(isFreeTrial).getCartItems(cartId);
        const freeGiftErrors = freeGiftsWithErrors
            .flatMap((item) => (item.errors || []).map((error) => ({
            errorCode: error.code,
            parentId: item.parentGiftId,
            parentSku: item.parentGiftSku,
        })))
            .filter((error) => !!error);
        dispatch(setFreeGiftsErrors(freeGiftErrors));
    }
    if (isFreeTrial) {
        dispatch(fetchTrialCartPrices(cartId));
    }
    else {
        dispatch(fetchCartPrices(cartId));
    }
    return items;
}));
export const fetchCartItems = fetchItemsDeclaration(false);
export const fetchTrialCartItems = fetchItemsDeclaration(true);
export const fetchCleanCartItems = fetchCartItemsWithValidations(false);
export const fetchTrialCleanCartItems = fetchCartItemsWithValidations(true);
//# sourceMappingURL=fetchCartItems.js.map